export enum BaseAssetShortcode {
  Bitcoin = 'BTC',
  Ethereum = 'ETH',
  BitcoinCash = 'BCH',
  Litecoin = 'LTC',
  Dash = 'DASH',
  Cardano = 'ADA',
  Eos = 'EOS',
  Doge = 'DOGE',
  Solana = 'SOL',
  Tron = 'TRX',
  Lumen = 'XLM',
  PolygonMatic = 'MATIC',
  Ripple = 'XRP',
  Tezos = 'XTZ',
  LunaClassic = 'LUNA',
  Luna2 = 'LUNA2',
  Polkadot = 'DOT',
  BNB = 'BNB',
  Celo = 'CELO',
  Avalanche = 'AVAX',
  Algorand = 'ALGO',
  EthereumClassic = 'ETC',
  Waves = 'WAVES',
  CosmosHub = 'ATOM_COS',
  NEAR = 'NEAR',
  BitcoinSV = 'BSV',
}

export const BASE_ASSETS = new Set(Object.values(BaseAssetShortcode));
